import Anchor from 'containers/ac-containers/ac-anchor';
import { useTranslation } from 'hooks/use-translation';
import { useModalContext } from 'hooks/useModalContext';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import {
	AppointmentSection,
	InteractionSection,
	ClassesSection,
	ClassRoomSection,
	GlobalOnlineSchoolSection,
	MapCoversSection,
	RatingSection,
	ExamStress,
	SafeguardSection
} from './components';
import styles from './styles.scss';
import { keyCountMap } from '@services/test-form';
import { setOpenHomeFormTime } from '@utils/testForm';

/**
 * 6过落地页
 */

export default function MainHome() {
	const anchor = useHistory().location.hash;
	const { setTrigger, setVisibleEnTestFormModal, setEvent, setEnTestFormModalData } = useModalContext();
	const { transData } = useTranslation('home');
	const local = useSelector((state: ConnectState) => state.app.local);
	const storageLang = localStorage.getItem('__lang') || 'en';

	const getCount = async () => {
		setTrigger(true);
		// // 英文状态下 5-5概率展示A/B弹窗
		// if (local === 'en') {
		// 	setOpenHomeFormTime();
		// 	keyCountMap({}).then((res: any) => {
		// 		if (res.code === '0') {
		// 			if (!res.data.B || Number(res.data.A) > Number(res.data.B)) {
		// 				setVisibleEnTestFormModal(true);
		// 				setEnTestFormModalData({ sourceKey: 'B' });
		// 			} else {
		// 				setTrigger(true);
		// 				setEnTestFormModalData({ sourceKey: 'A' });
		// 			}
		// 		} else {
		// 			setTrigger(true);
		// 			setEnTestFormModalData({ sourceKey: 'A' });
		// 		}
		// 	});
		// } else {
		// 	setTrigger(true);
		// }
	};

	useEffect(() => {
		if (!anchor) {
			window.scrollTo(0, 0);
		}
	}, []);

	return (
		<div className={styles['ac-container']}>
			<main className={styles['ac-home']}>
				<AppointmentSection />
				<InteractionSection />
				{/* {storageLang === 'en' && <ExamStress />} */}
				{/* <ClassesSection /> */}
				{/* <ClassRoomSection /> */}
				{/* <GlobalOnlineSchoolSection />
				<Anchor className={styles.anchor} anchorText={'appointment'} eventId="PAG_aa338e2331a83a1b">
					<img src={transData.toTop} alt="" loading="lazy" />
				</Anchor> */}
				<SafeguardSection />
				<RatingSection />
				<MapCoversSection />
			</main>
		</div>
	);
}
